// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  padding: 16px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.logo .simple-text {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #e5e7eb;
  text-decoration: none;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.logo-img img {
  height: 38px;
  width: auto;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  padding: 6px;
}

.logo-label {
  font-size: 14px;
}

.sidebar-wrapper {
  padding: 12px 8px 16px;
  overflow-y: auto;
  height: calc(100vh - 140px);
}

.sidebar-wrapper .nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 6px;
}

.sidebar-wrapper .nav-item .nav-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin: 0 6px;
  border-radius: 12px;
  color: #e5e7eb;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}

.sidebar-wrapper .nav-item .nav-link i {
  color: #a5b4fc;
}

.sidebar-wrapper .nav-item.active .nav-link,
.sidebar-wrapper .nav-item .nav-link:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.sidebar-wrapper .nav-item.active .nav-link i {
  color: #fbbf24;
}

.sidebar-footer {
  padding: 12px 18px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: #ffffff;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.04);
}

.sidebar-footer .logo-label {
  font-weight: 700;
  letter-spacing: 0.2px;
  color: #ffffff;
}

.sidebar-footer .logo-label p {
  margin: 0;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./projects/admin/src/components/core/sidebar/sidebar.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB","sourcesContent":[".logo {\n  padding: 16px 18px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.logo .simple-text {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #e5e7eb;\n  text-decoration: none;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n}\n\n.logo-img img {\n  height: 38px;\n  width: auto;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.08);\n  padding: 6px;\n}\n\n.logo-label {\n  font-size: 14px;\n}\n\n.sidebar-wrapper {\n  padding: 12px 8px 16px;\n  overflow-y: auto;\n  height: calc(100vh - 140px);\n}\n\n.sidebar-wrapper .nav {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 6px;\n}\n\n.sidebar-wrapper .nav-item .nav-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  margin: 0 6px;\n  border-radius: 12px;\n  color: #e5e7eb;\n  text-decoration: none;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.sidebar-wrapper .nav-item .nav-link i {\n  color: #a5b4fc;\n}\n\n.sidebar-wrapper .nav-item.active .nav-link,\n.sidebar-wrapper .nav-item .nav-link:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n.sidebar-wrapper .nav-item.active .nav-link i {\n  color: #fbbf24;\n}\n\n.sidebar-footer {\n  padding: 12px 18px 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n  font-size: 12px;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.sidebar-footer .logo-label {\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  color: #ffffff;\n}\n\n.sidebar-footer .logo-label p {\n  margin: 0;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
